<template>
    <div>
        <el-table
            v-if="isLoading === false"
            :data="tableData"
            style="width: 100%"
            class="fresh-seed-bag-table"
            size="mini"
            :header-cell-style="{ background: '#F5F7FA' }"
            border
        >
            <el-table-column
                type="index"
                width="30"
            />
            <el-table-column
                prop="progeny.code"
                label="Progeny"
                min-width="85"
            />
            <el-table-column
                prop="freshSeedBag.qrCode.code"
                label="Fresh Seed QR Code"
                min-width="75"
            />
            <el-table-column
                prop="germinatedSeedBag.qrCode.code"
                label="Germ. Seed QR Code"
                min-width="75"
            />
            <el-table-column
                prop="amount"
                label="Amount"
                width="70"
            />
        </el-table>
        <p v-else>Loading...</p>
    </div>
</template>

<script>
import { germinationBatchTransasctionGetAll, germinationBatchTransasctionDelete } from "@/api/germination_batch_transaction";

export default {
    props: {
        batchId: {
            type: String | Number
        }
    },
    data() {
        return {
            tableData: [],
            isLoading: false,
        };
    },
    watch: {
        batchId: {
            immediate: true,
            handler() {
                this.getGerminationBatchTransaction();
            },
        },
        isLoading() {
            if (this.isLoading === true) {
                this.tableData = [];
            }
        }
    },
    methods: {
        async getGerminationBatchTransaction () {
            this.isLoading = true;
            let res = await germinationBatchTransasctionGetAll({ "GerminationBatchId": this.batchId });
            if (res) {
                this.tableData = res.items;
            }
            this.isLoading = false;
        },
        async handleDelete(index, row) {
            let res = await germinationBatchTransasctionDelete({ "Id": row.id });
            if (res) {
                EventBus.$emit("snackBar", {
                    text: "Transaction Deleted",
                    snackbarColor: "green"
                });

                this.$emit("removeTransaction", {
                    "Id": row.id,
                    "Index": index
                });
            }
        }
    },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/GerminationBatchTransaction/GerminationBatchTransactionSimpleTable.vue